import _firebase, {
    providerFB,
    providerGG,
    setNode as FBSetNode,
    addRefIfNotExists as FBAddRefIfNotExists,
    // getNode as FBGetNode,
    // addNewRef as FBAddNewRef,
    // getNodeOrderBy as FBGetNodeOrderBy,
    getDeepWithOrderBy as FBGetDeepWithOrderBy
} from "~/firebase";

const prefix = "account.actions";
const getActionType = (type: string) => `${prefix}.${type}`;
export const hasActionsType = (type: string) => ~type.indexOf(prefix) !== 0;

export const ACCOUNT_LOGIN = getActionType("ACCOUNT_LOGIN");

const ERROR_LOGIN_FAILED = "Email or password incorrect!";
const ERROR_USER_EXITS = "Email is exists!";
const ERROR_LOGIN_FB_FAILED = "Can not login with Facebook";
const ERROR_LOGIN_GG_FAILED = "Can not login with Google";

const catchError = (er: any) => (data: any) => Promise.reject(er);

export const loginWithFacebook = () => (dispatch: Function) => {
    return _firebase.auth().signInWithPopup(providerFB)
        .then((result) => Promise.resolve(result.additionalUserInfo))
        .then((additionalUserInfo: any) => Promise.resolve(additionalUserInfo.profile))
        .then(profile => {
            return FBSetNode(`users/facebook/${profile.id}`, {
                id: profile.id,
                email: profile.email,
                fullname: profile.name,
                photoURL: profile.picture.data.url,
            })
                .then(account => {
                    // console.log(account);
                    dispatch({
                        type: ACCOUNT_LOGIN,
                        account
                    })
                }).catch(catchError(ERROR_LOGIN_FAILED))
        })
        .catch(er => {
            console.log(er);
            return catchError(ERROR_LOGIN_FB_FAILED)("Facebook");
        })
}

export const loginWithGoogle = () => (dispatch: Function) => {
    return _firebase.auth().signInWithPopup(providerGG)
        .then((result) => Promise.resolve(result.additionalUserInfo))
        .then((additionalUserInfo: any) => Promise.resolve(additionalUserInfo.profile))
        .then(profile => {
            return FBSetNode(`users/google/${profile.id}`, {
                id: profile.id,
                email: profile.email,
                fullname: profile.name,
                photoURL: profile.picture,
            })
                .then(account => {
                    // console.log(account);
                    dispatch({
                        type: ACCOUNT_LOGIN,
                        account
                    })
                }).catch(catchError(ERROR_LOGIN_FAILED))
        })
        .catch(er => {
            console.log(er);
            return catchError(ERROR_LOGIN_GG_FAILED)("Google");
        })
}

/**
 * 
 * @param user 
 */
interface IUser {
    email: string;
    password: string;
}
export const loginLocal = (user: IUser) => (dispatch: Function) => {
    return FBGetDeepWithOrderBy(
        "users/local",
        "email", user.email,
        user
    )
        .then(account => {
            // console.log(account);
            dispatch({
                type: ACCOUNT_LOGIN,
                account
            })
        }).catch(catchError(ERROR_LOGIN_FAILED))
}

interface IUserRegister {
    email: string;
    password: string;
    fullname: string;
    photoURL?: "/assets/images/default-avatar.png";
}

export const registerLocal = (user: IUserRegister) => (dispatch: Function) => {
    return FBAddRefIfNotExists(
        "users/local",
        "email", user.email,
        user
    )
        .then(account => {
            dispatch({
                type: ACCOUNT_LOGIN,
                account: account,
            })
        }).catch(catchError(ERROR_USER_EXITS))
}


export const ACCOUNT_LOGOUT = getActionType("ACCOUNT_LOGOUT");
export const logout = () => {
    return {
        type: ACCOUNT_LOGOUT,
    }
}



// WEBPACK FOOTER //
// ./src/actions/account.ts